import React, {useState, useEffect} from 'react';
import {t} from 'react-switch-lang';
import {getLanguage} from 'react-switch-lang';
import FormatList from './reportForm/components/format/FormatList';
import DownloadBtn from './reportForm/components/downloadBtn/DownloadBtn';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import './Reports.scss';
import {format} from 'date-fns';
import {useUserContext} from '../../contexts/UserContext';
import * as yup from 'yup';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';

const Litigation = (props) => {
  const isValidType = '';

  const [selectedFormat, setSelectedFormat] = useState();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [format2, setFormat2] = useState('');

  const schema = yup.object().shape({
    department: yup.object().nullable().required(t('message.fieldRequired')),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {watch, setValue} = methods;
  let validFrom = watch('startDate');
  let validTo = watch('endDate');

  const user = useUserContext();
  // const departments = useUserDepartmentContext();
  let userRiskSector = false;
  let responsibleUser = false;
  let userInCharge = false;

  if (user.authorities) {
    user.authorities.forEach((item) => {
      if (item === 'ROLE_RISK_SECTOR') {
        userRiskSector = true;
      }
      if (item === 'ROLE_RESPONSIBLE_USER') {
        responsibleUser = true;
      }
      if (item === 'ROLE_USER_IN_CHARGE') {
        userInCharge = true;
      }
    });
  }

  useEffect(() => {
    setSelectedFormat();
    setIsSubmitted(false);
    setValue('endDate', new Date());
    setValue(
      'startDate',
      new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    );
  }, []);


  return (
    <div className="reports-page content">
      <FormProvider {...methods}>
        <div className="report-form-container" key={window.location.pathname}>
          <div className="row  ml-0 mr-0">
            <div className="form-group pr-5">
              <label className="label" htmlFor="startDate">
                {t('reports.dateFrom')}
              </label>
              <InputDate
                name="startDate"
                maxDate={validTo}
                defaultValue={
                  new Date(new Date().getFullYear(), new Date().getMonth(), 1)
                }
                className={`date-height form-control ${
                  validTo === null && isSubmitted === true ? `error-field` : ''
                }`}
                isClearable={false}
                placeholderText={t('reports.dateFrom')}
              />
              {validTo === null && isSubmitted === true ? (
                <span className="error-message position-absolute">
                  {t('message.fieldRequired')}
                </span>
              ) : (
                ''
              )}
            </div>
            <div className="form-group pr-5">
              <label className="label" htmlFor="endDate">
                {t('reports.dateTo')}
              </label>
              <InputDate
                name="endDate"
                minDate={validFrom}
                defaultValue={new Date()}
                className={`date-height form-control ${
                  validFrom === null && isSubmitted === true
                    ? `error-field`
                    : ''
                }`}
                isClearable={false}
                placeholderText={t('reports.dateTo')}
              />
              {validFrom === null && isSubmitted === true ? (
                <span className="error-message position-absolute">
                  {t('message.fieldRequired')}
                </span>
              ) : (
                ''
              )}
            </div>
            <FormatList
              isValidType={isValidType}
              value={['PDF', 'XLSX']}
              parameterName="format"
              onChange={(e) => setFormat2(e)}
              isSubmitted={isSubmitted}
              setIsSubmitted={() => setIsSubmitted(false)}
              setSelectedFormat={(e) => setSelectedFormat(e.toLowerCase())}
              error={!format2.length > 0}
            />
            <DownloadBtn
              api={'reports/risks/court-risk-report'}
              paramsLength={3}
              setIsSubmitted={(e) => setIsSubmitted(e)}
              // documentName={format2}
              documentName={`PDF`}
              apiParameters={{
                format: format2,
                startDate:
                  validFrom !== null && validFrom !== undefined
                    ? `startDate=${encodeURIComponent(
                        format(validFrom, 'yyyy-MM-dd')
                      )}`
                    : '',
                endDate:
                  validTo !== null && validTo !== undefined
                    ? `endDate=${encodeURIComponent(
                        format(validTo, 'yyyy-MM-dd')
                      )}`
                    : '',
              }}
            />{' '}
          </div>
        </div>
      </FormProvider>
    </div>
  );
};

export default Litigation;
